import { EllipsisText, type GridColDef } from '@shared/components';

export interface QSetGeneratorResultColumn {
  id: string;
  code: string;
  averageDuplicationRate: number;
  totalQuestions: number;
  qConfig: {
    id: string;
    name: string;
    code: number;
  };
}

export const columns: GridColDef<QSetGeneratorResultColumn>[] = [
  {
    field: 'code',
    headerName: 'QSet ID',
    flex: 1,
    sortable: false,
  },
  {
    field: 'averageDuplicationRate',
    headerName: 'Average Duplicate Rate',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      const { averageDuplicationRate, totalQuestions } = params.row;
      // NOTE: We need to round the average duplication rate to 3 decimal places before calculating the total average questions.
      // This is because of JavaScript's floating-point arithmetic limitations.
      const totalAvgQuestions = Math.ceil(
        Math.round((averageDuplicationRate / 100) * (totalQuestions * 1000)) / 1000,
      );

      return (
        <>
          {averageDuplicationRate.toFixed(2)}% ({totalAvgQuestions} ข้อ)
        </>
      );
    },
  },
  {
    field: 'qConfig.name',
    headerName: 'QConfig Name',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      return <EllipsisText>{params.row.qConfig.name}</EllipsisText>;
    },
  },
  {
    field: 'qConfig.code',
    headerName: 'QConfig ID',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      return <>{params.row.qConfig.code}</>;
    },
  },
];
